import SVG from './SVG'
import * as T from './types'

const VideoCamera = (props: T.ISVGProps) => (
  <SVG
    {...props}
    viewBox="0 0 34 24"
    fillRule="evenodd"
    clipRule="evenodd"
    d="M23.6654 0.5H3.66536C1.82442 0.5 0.332031 1.99238 0.332031 3.83333V20.5C0.332031 22.341 1.82442 23.8333 3.66536 23.8333H23.6654C25.5063 23.8333 26.9987 22.341 26.9987 20.5V15.5L31.5154 20.0167C31.8258 20.3246 32.2448 20.4982 32.682 20.5H32.832C33.2923 20.5 33.6654 20.1269 33.6654 19.6667V4.66667C33.6654 4.20643 33.2923 3.83333 32.832 3.83333H32.682C32.2448 3.83517 31.8258 4.00876 31.5154 4.31667L26.9987 8.83333V3.83333C26.9987 1.99238 25.5063 0.5 23.6654 0.5ZM23.6651 3.83333V20.5H3.66511V3.83333H23.6651ZM6.99896 9.46666C6.99896 9.9269 7.37205 10.3 7.83229 10.3H14.499C14.9592 10.3 15.3323 9.9269 15.3323 9.46666V8.19999C15.3323 7.73976 14.9592 7.36666 14.499 7.36666H7.83229C7.37205 7.36666 6.99896 7.73976 6.99896 8.19999V9.46666Z"
  />
)

export default VideoCamera
